import { render, staticRenderFns } from "./YokNotifications.vue?vue&type=template&id=185eb70a"
import script from "./YokNotifications.vue?vue&type=script&lang=js"
export * from "./YokNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports